<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">{{ this.$route.name }}</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/ptSession')" class="btn-grey">
              <i class="fas fa-arrow-circle-left mr-5"></i>Back
            </a>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>PT Tier</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="pt_tier" v-validate="'required'" v-model="editData.pt_tier" :options="optTier"
                      class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('pt_tier') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>MBG Tier</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="mbg_tier" v-validate="'required'" v-model="editData.mbg_tier" :options="mbgTier"
                      class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first("mbg_tier") }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Price</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.price" name="price" v-validate="'required|decimal:2'"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first('price') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Normal Price</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.price_normal" name="price_normal" v-validate="'required|decimal:2'"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first("price_normal") }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Quantity</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.quantity" name="quantity" v-validate="'required|numeric'"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first('quantity') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Expired in Days</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.expired_in_days" name="expired_in_days"
                    v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('expired_in_days') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Additional Expired in Days</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.additional_expired_in_days" name="additional_expired_in_days"
                    v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('additional_expired_in_days') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Keysoft Part ID</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.keysoft_part_id" name="keysoft_part_id" type="text"></b-form-input>
                  <span class="error">{{ errors.first('keysoft_part_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Group Member Qty</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="group_member_qty" v-validate="'required'" v-model="editData.group_member_qty"
                      :options="group_member_qty" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first("pt_tier") }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Status</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="editData.status" :options="options"
                      class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";

export default {
  name: "addSession",
  data: function () {
    return {
      editData: {
        name: "",
        pt_tier: "",
        group_member_qty: 1,
        price: "",
        quantity: "",
        expired_in_days: "",
        additional_expired_in_days: "",
        keysoft_part_id: "",
        status: null,
        price_normal: "",
        mbg_tier: 0
      },
      group_member_qty: [
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        { value: 4, text: "4" },
        { value: 5, text: "5" },
        { value: 6, text: "6" },
        { value: 7, text: "7" },
        { value: 8, text: "8" },
        { value: 9, text: "9" }
      ],
      options: [
        { value: null, text: "Please select" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" }
      ],
      optTier: [
        { value: "", text: "Please select" },
        { value: "1", text: "Tier 1" },
        { value: "2", text: "Tier 2" },
        { value: "3", text: "Tier 3" },
        { value: "4", text: "Tier 3 + Expat" },
        { value: "5", text: "Tier 1 New" },
        { value: "10", text: "Tier 10" },
        { value: "11", text: "Tier Staff" },
        { value: "12", text: "Tier Dance" }
      ],
      mbgTier: [
        { value: 0, text: "Please select" },
        { value: 2, text: "Tier 2" },
        { value: 3, text: "Tier 3" },
      ]
    };
  },
  methods: {
    // onEditorChange(event) {
    //   console.log('onEditorChange')
    // },
    validateRegister() {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios
            .put("fitness/v1/pt_session/" + this.$route.query.id, this.editData)
            .then(response => {
              // console.log('test', response)
              this.$router.push("/ptSession");
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    openPage(event) {
      this.$router.push(event);
    },
    fetchData() {
      // pt tier
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/pt_tier?page=&limit=').then(response => {
        // this.items = response.data.data.rows
        // this.totalPage = response.data.meta.pageCount
        this.optTier = []
        this.optTier.push({ value: "", text: "Please select" })
        for (let i = 0; i < response.data.data.rows.length; i++) {
          const el = response.data.data.rows[i];
          this.optTier.push({ value: `${el.id}`, text: `${el.name}` })
        }
        console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })


      axios
        .get("fitness/v1/pt_session/" + this.$route.query.id)
        .then(response => {
          this.editData = response.data.data;
          // console.log('test', response.data.data)
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style lang="scss" scoped>
</style>
